import { render, staticRenderFns } from "./PopupEditor.vue?vue&type=template&id=6ea9e124&scoped=true"
import script from "./PopupEditor.vue?vue&type=script&lang=js"
export * from "./PopupEditor.vue?vue&type=script&lang=js"
import style0 from "./PopupEditor.vue?vue&type=style&index=0&id=6ea9e124&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea9e124",
  null
  
)

export default component.exports